// extracted by mini-css-extract-plugin
export default {"no-border-right":"no-border-right--Z_NfI"};